import HttpService from '~/zf/frontend/common/http/HttpService';
import PowerFlowConfigurationEndpoint from './const/PowerFlowConfigurationEndpoint';
import Endpoint from '~/zf/frontend/common/acl/const/Endpoint';

async function get(systemId) {
  const response = await HttpService.post(
    PowerFlowConfigurationEndpoint.GET,
    { systemId },
  );
  return response.data;
}

/**
 * @param {int} systemId
 * @param {string[]} abbreviations
 * @return {Promise<{string: object[]}>} device data grouped by abbreviation
 */
async function getMeters(systemId, abbreviations) {
  const response = await HttpService.post(
    PowerFlowConfigurationEndpoint.GET_METERS,
    { systemId, abbreviations },
  );
  return response.data;
}

async function getBatteries(systemId) {
  const response = await HttpService.post(
    PowerFlowConfigurationEndpoint.GET_BATTERIES,
    { systemId },
  );
  return response.data;
}

async function getConfig(systemId) {
  const response = await HttpService.post(
    PowerFlowConfigurationEndpoint.GET_CONFIG,
    { systemId },
  );
  return response.data;
}

async function hasAccessToTermSelection(systemId) {
  const response = await HttpService.post(
    Endpoint.HAS_ACCESS_TO_TERM_SELECTION,
    { systemId },
  );
  return response.data;
}

async function savePvProduction(measuredValue, systemId) {
  const response = await HttpService.post(
    PowerFlowConfigurationEndpoint.SAVE_PV_PRODUCTION,
    { systemId, measuredValue },
  );
  return response.data;
}

async function saveConsumption(config, systemId) {
  const response = await HttpService.post(
    PowerFlowConfigurationEndpoint.SAVE_CONSUMPTION,
    { systemId, config },
  );
  return response.data;
}

async function saveGrid(config, systemId) {
  const response = await HttpService.post(
    PowerFlowConfigurationEndpoint.SAVE_GRID,
    { systemId, config },
  );
  return response.data;
}

async function saveBattery(batteryIds, systemId) {
  await HttpService.post(
    PowerFlowConfigurationEndpoint.SAVE_BATTERY,
    { systemId, batteryIds },
  );
}

async function saveWizard(systemId, pvMeasuredValue, consumptionConfig, gridConfig, batteryIds) {
  await HttpService.post(
    PowerFlowConfigurationEndpoint.SAVE_WIZARD,
    {
      systemId, pvMeasuredValue, consumptionConfig, gridConfig, batteryIds,
    },
  );
}

export default {
  get,
  getMeters,
  getBatteries,
  getConfig,
  hasAccessToTermSelection,
  savePvProduction,
  saveConsumption,
  saveGrid,
  saveBattery,
  saveWizard,
};
